import React, { useState } from "react";
import { Modal, Button, Form, Input, message, Spin } from "antd"; // Added Spin for loading state
import { db } from "../../../firebase";
import { IoPersonRemove } from "react-icons/io5";
import { IoIosRemoveCircle } from "react-icons/io";
import {
  collection,
  doc,
  setDoc,
  query,
  where,
  getDocs,
  limit,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";
import "./CMERegistration.css"; // Import the updated CSS
import Navbar from "../../../components/navigationbar/Navbar";
import Footer from "../../../components/Footer/Footer";

function CMERegistration() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const [cmeSubjects, setCmeSubjects] = useState([]);
  const [currentSubject, setCurrentSubject] = useState("");
  const [doctorNames, setDoctorNames] = useState([]);
  const [currentDoctor, setCurrentDoctor] = useState("");

  const [formValues, setFormValues] = useState({
    email: "",
    phone: "",
    hospital: "",
    doctor: "",
    id: "",
  });
  const [isLoading, setIsLoading] = useState(false); // Loading state for submit
  const navigate = useNavigate();

  // Open new registration modal
  const handleNewRegistration = () => {
    setIsModalVisible(true);
    setIsCheckingStatus(false);
  };

  // Open status check modal
  const handleAlreadyRegistered = () => {
    setIsModalVisible(true);
    setIsCheckingStatus(true);
  };

  //handle add doctorand subject

  // Add a subject to the list
  // Add a subject to the list
  const handleAddSubject = () => {
    const trimmedSubject = currentSubject.trim();
    if (trimmedSubject) {
      setCmeSubjects((prevSubjects) => [...prevSubjects, trimmedSubject]);
      setCurrentSubject(""); // Clear the input field
      message.success("Subject added successfully.");
    } else {
      message.error("Please enter a valid subject before adding.");
    }
  };

  // Remove a subject from the list
  const handleRemoveSubject = (index) => {
    setCmeSubjects((prevSubjects) =>
      prevSubjects.filter((_, i) => i !== index)
    );
    message.info("Subject removed.");
  };

  // Add a doctor's name to the list
  // Add a doctor's name to the list
  const handleAddDoctor = () => {
    const trimmedDoctor = currentDoctor.trim();
    if (trimmedDoctor) {
      setDoctorNames((prevDoctors) => [...prevDoctors, trimmedDoctor]);
      setCurrentDoctor(""); // Clear the input field
      message.success("Doctor added successfully.");
    } else {
      message.error("Please enter a valid doctor's name before adding.");
    }
  };

  // Remove a doctor's name from the list
  const handleRemoveDoctor = (index) => {
    setDoctorNames((prevDoctors) => prevDoctors.filter((_, i) => i !== index));
    message.info("Doctor removed.");
  };

  // Handle form submission for new registrations
  const handleSubmitNewRegistration = async () => {
    if (cmeSubjects.length === 0) {
      message.error("Please add at least one CME Subject before submitting.");
      return;
    }
  
    if (doctorNames.length === 0) {
      message.error("Please add at least one Doctor's Name before submitting.");
      return;
    }
    const uniqueId = generateUniqueId();
    const subject = "CME Registration Confirmation";
    const text = "Your unique ID is: " + uniqueId;
    setIsLoading(true);

    try {
      await setDoc(doc(db, "CME-requests", uniqueId), {
        ...formValues,
        doctorNames,
        cmeSubjects,
        id: uniqueId,
        status: "Pending",
      });

      // Trigger email API
      await fetch("https://gpa-backend-1x73.onrender.com/api/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          recipientEmail: formValues.email,
          subject,
          text,
        }),
      });

      message.success("Unique ID sent to your email");
      // sendSmsToUser(formValues.phone, uniqueId);
      navigate(`/Request/${uniqueId}`);
      setIsModalVisible(false);
    } catch (error) {
      console.error("Error adding document:", error);
      message.error("Failed to register. Please try again.");
    } finally {
      setIsLoading(false); // Stop loading after submission attempt
    }
  };

  //   function sendSmsToUser(phoneNumber, username) {
  //   // Check if the phone number starts with +91, otherwise prepend it
  //   if (!phoneNumber.startsWith('+91')) {
  //     phoneNumber = '+91' + phoneNumber;  // Prepend country code
  //   }

  //   const myHeaders = new Headers();
  //   myHeaders.append("Authorization", "App e0a85bb4513ef8294326ddf8528345de-02a627d8-f865-456e-a9c8-d32a5e8ff443");
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Accept", "application/json");

  //   const raw = JSON.stringify({
  //     "messages": [
  //       {
  //         "destinations": [{"to": phoneNumber}],
  //         "from": "447491163443",
  //         "text": `Congratulations! Your registration is successful.\nYour UID is: ${username}`
  //       }
  //     ]
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow"
  //   };

  //   fetch("https://kqxwq8.api.infobip.com/sms/2/text/advanced", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log('SMS sent successfully:', result);
  //     })
  //     .catch((error) => {
  //       console.error('Error sending SMS:', error);
  //     });
  // }

  // Handle status check for already registered users
  const handleCheckStatus = async () => {
    setIsLoading(true);
    try {
      const q = query(
        collection(db, "CME-requests"),
        where("id", "==", formValues.id),
        limit(1)
      );
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const requestData = snapshot.docs[0].data();

        // Verify email and phone match
        if (
          requestData.email === formValues.email &&
          requestData.phone === formValues.phone
        ) {
          navigate(`/Request/${formValues.id}`);
        } else {
          message.error(
            "Verification failed: Incorrect email or phone number."
          );
        }
      } else {
        message.error("No record found for the provided ID.");
      }
    } catch (error) {
      console.error("Error during status check:", error);
      message.error("Failed to verify. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Handle input change for form fields
  const handleFormChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  return (
    <>
      <Navbar />
      <div className="registration-container">
        <div className="header">
          <h1>Welcome to CME Registration</h1>
          <p>Register for CME events or check your approval status</p>
        </div>

        <div className="buttons-container">
          <Button
            className="registration-button"
            onClick={handleNewRegistration}
          >
            New Registration
          </Button>
          <Button
            className="registration-button"
            onClick={handleAlreadyRegistered}
          >
            Already Registered
          </Button>
        </div>

        {isLoading && (
          <div className="loading-container">
            <div className="loading-overlay">
              <Spin size="large" className="loading-spinner" />
            </div>
          </div>
        )}

        <Modal
          title={
            isCheckingStatus ? "Check Approval Status" : "New Registration"
          }
          visible={isModalVisible}
          onOk={
            isCheckingStatus ? handleCheckStatus : handleSubmitNewRegistration
          }
          onCancel={() => setIsModalVisible(false)}
          okButtonProps={{
            disabled: !formValues.email || !formValues.phone,
          }}
          className="registration-modal"
        >
          <Form layout="vertical" className="registration-form">
            {isCheckingStatus ? (
              <>
                <span style={{ color: "green" }}>
                  Enter the unique ID that was sent to your email during
                  registration.{" "}
                </span>
                <Form.Item label="Unique ID" required className="form-item">
                  <Input
                    name="id"
                    onChange={handleFormChange}
                    placeholder="Enter your unique ID"
                  />
                </Form.Item>
                <Form.Item label="Email" required className="form-item">
                  <Input
                    name="email"
                    onChange={handleFormChange}
                    placeholder="Enter your email"
                    type="email"
                  />
                </Form.Item>
                <Form.Item label="Phone Number" required className="form-item">
                  <Input
                    name="phone"
                    onChange={handleFormChange}
                    placeholder="Enter your phone number"
                    type="tel"
                  />
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item label="Hospital Name" required className="form-item">
                  <Input
                    name="hospital"
                    onChange={handleFormChange}
                    placeholder="Enter the hospital name"
                  />
                </Form.Item>
                <Form.Item
                  label="Doctor's Names"
                  required
                  className="form-item"
                >
                  <Input
                    value={currentDoctor}
                    onChange={(e) => setCurrentDoctor(e.target.value)}
                    placeholder="Enter the doctor's name"
                  />
                  <Button
                    type="primary"
                    onClick={handleAddDoctor}
                    style={{ marginTop: "10px" }}
                  >
                    Add Doctor
                  </Button>
                  <ul className="list-container">
                    {doctorNames.map((name, index) => (
                      <li key={index}>
                        {name}
                        <Button
                          type="link"
                          danger
                          onClick={() => handleRemoveDoctor(index)}
                          // style={{ padding: 0 }}
                          style={{
                            marginLeft:"10px",
                            
                            fontSize: "15px",  // Adjust the size
                            color: "#ff0000",  // Set color (e.g., red)
                            cursor: "pointer", // Add cursor pointer on hover
                            transition: "transform 0.3s",  // Add transition effect
                          }} 
                        >
                          <IoPersonRemove />
                        </Button>
                      </li>
                    ))}
                  </ul>
                </Form.Item>
                <Form.Item label="Email" required className="form-item">
                  <Input
                    name="email"
                    onChange={handleFormChange}
                    placeholder="Enter your email"
                    type="email"
                  />
                </Form.Item>
                <Form.Item label="Phone Number" required className="form-item">
                  <Input
                    name="phone"
                    onChange={handleFormChange}
                    placeholder="Enter your phone number"
                    type="tel"
                  />
                </Form.Item>
                <Form.Item label="CME Subjects" required className="form-item">
                  <Input
                    value={currentSubject}
                    onChange={(e) => setCurrentSubject(e.target.value)}
                    placeholder="Enter a CME subject"
                  />
                  <Button
                    type="primary"
                    onClick={handleAddSubject}
                    style={{ marginTop: "10px" }}
                  >
                    Add Subject
                  </Button>
                  <ul className="list-container">
                    {cmeSubjects.map((subject, index) => (
                      <li key={index}>
                        {subject}
                        <Button
                          type="link"
                          danger
                          onClick={() => handleRemoveSubject(index)}
                          style={{
                          
                            marginLeft:"10px",
                            
                            fontSize: "15px",  // Adjust the size
                            color: "#ff0000",  // Set color (e.g., red)
                            cursor: "pointer", // Add cursor pointer on hover
                            transition: "transform 0.3s",  // Add transition effect
                          }}
                        >
                         <IoIosRemoveCircle />
                        </Button>
                      </li>
                    ))}
                  </ul>
                </Form.Item>
              </>
            )}
          </Form>
        </Modal>
      </div>
      <Footer />
    </>
  );
}

// Utility function to generate a unique ID
const generateUniqueId = (() => {
  const generatedIds = new Set(); // To store already generated IDs

  return () => {
    let uniqueId;

    do {
      const timestamp = Date.now().toString(36).slice(-5); // Convert timestamp to base-36 and take the last 5 characters
      const randomPart = Math.random().toString(36).substring(2, 7); // Generate a random alphanumeric string of 5 characters
      uniqueId = `CME-${timestamp}${randomPart}`; // Combine timestamp and random part
    } while (generatedIds.has(uniqueId)); // Ensure ID is not repeated

    generatedIds.add(uniqueId); // Track the generated ID
    return uniqueId;
  };
})();

export default CMERegistration;
